module.exports = __webpack_public_path__ + "static/media/pruefung_der_wirksamkeit_active.77b0fce8.jpg";